export class PlanejamentoFiltroDto {
    AnoSafraIds: number[] = [];
    CulturaIds: number[] = [];
    FazendaIds: number[] = [];

    constructor() {
        this.AnoSafraIds = [];
        this.CulturaIds = [];
        this.FazendaIds = [];
    }
}
